"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Notice = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const button_utils_1 = require("@/components/common/button/button.utils");
const icon_names_1 = require("@/components/common/icon/icon-names");
const notice_styles_1 = require("@/components/common/notice/notice.styles");
const utils_1 = require("@/utils");
require("@/components/common/button/button");
require("@/components/common/button/button-group");
require("@/components/common/icon");
require("@/components/common/text/text");
require("@/components/common/text/semantics/heading");
require("@/components/common/icon-button/semantics/dismiss-button");
let Notice = class Notice extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.role = 'note';
        this.heading = '';
        this.description = '';
        this.variant = 'info';
        this.dismissed = false;
        this.dismissible = false;
        this.dismissListenerCount = 0;
    }
    render() {
        if (this.dismissed)
            return (0, lit_1.html) ``;
        return (0, lit_1.html) `
      <mm-icon name=${this.icon} class="notice-icon"></mm-icon>
      <div class="notice-content">
        ${this.renderText()}
        <slot></slot>
      </div>
      ${this.renderActions()}
    `;
    }
    renderText() {
        if (!this.heading && !this.description)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <div class="notice-text">${this.renderHeading()} ${this.renderDescription()}</div>
    `;
    }
    renderHeading() {
        if (!this.heading)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-heading level="4">${this.heading}</mm-heading>
    `;
    }
    renderDescription() {
        if (!this.description)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-text size="14">${this.description}</mm-text>
    `;
    }
    renderActions() {
        if (!this.primaryAction && !this.secondaryAction && !this.dismissible)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <div class="notice-actions">
        ${(0, button_utils_1.renderActionButtons)({
            primaryAction: this.primaryAction,
            secondaryAction: this.secondaryAction,
        })}
        ${this.renderDismissButton()}
      </div>
    `;
    }
    renderDismissButton() {
        if (!this.dismissible)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-dismiss-button @dismiss=${this.handleDismiss}></mm-dismiss-button>
    `;
    }
    // 소비자가 dismiss를 구독할 때만 닫기 버튼을 노출한다.
    addEventListener(type, listener, options) {
        super.addEventListener(type, listener, options);
        if (type !== 'dismiss')
            return;
        this.dismissListenerCount += 1;
        this.dismissible = true;
    }
    removeEventListener(type, listener, options) {
        super.removeEventListener(type, listener, options);
        if (type !== 'dismiss')
            return;
        this.dismissListenerCount = Math.max(0, this.dismissListenerCount - 1);
        this.dismissible = this.dismissListenerCount > 0;
    }
    get icon() {
        return icon_names_1.STATUS_ICONS[this.variant];
    }
    // 버튼의 dismiss는 여기서 멈추고, notice 자신의 dismiss로 바꿔 알린다.
    handleDismiss(event) {
        event.stopPropagation();
        this.dismissed = true;
        (0, utils_1.emit)(this, 'dismiss');
    }
};
Notice.styles = [notice_styles_1.noticeStyles];
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true })
], Notice.prototype, "role", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], Notice.prototype, "heading", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], Notice.prototype, "description", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true, useDefault: true })
], Notice.prototype, "variant", void 0);
__decorate([
    (0, decorators_js_1.property)({ attribute: false })
], Notice.prototype, "primaryAction", void 0);
__decorate([
    (0, decorators_js_1.property)({ attribute: false })
], Notice.prototype, "secondaryAction", void 0);
__decorate([
    (0, decorators_js_1.state)()
], Notice.prototype, "dismissed", void 0);
__decorate([
    (0, decorators_js_1.state)()
], Notice.prototype, "dismissible", void 0);
Notice = __decorate([
    (0, decorators_js_1.customElement)('mm-notice')
], Notice);
exports.Notice = Notice;
//# sourceMappingURL=data:application/json;base64,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